// utils/wechatPayment.js
// import Router from '../../src/router';
import wx from 'weixin-js-sdk'
/**
 * 微信支付封装函数
 * @param {Object} paymentParams 支付参数
 * @param {Function} successCallback 支付成功回调
 * @param {Function} failCallback 支付失败回调
 * @param {Function} cancelCallback 取消支付回调
 */
export function weChatPayment(paymentParams, successCallback, failCallback, cancelCallback) {
  const {
    appId,
    nonceStr,
    timestamp,
    paySign,
    packages,
    signType = 'RSA'
  } = paymentParams;
  // wx.config({
  //   debug: true,
  //   appId: appId,
  //   timestamp: timestamp,
  //   nonceStr: nonceStr,
  //   signature: paySign,
  //   jsApiList: ['checkJsApi', 'chooseWXPay'],
  // });
  // wx.ready(function () {
  //   wx.checkJsApi({
  //     jsApiList: ['chooseWXPay'],
  //     success: function (res) {
  //       // alert(JSON.stringify(res));
  //       // alert(JSON.stringify(res.checkResult.getLocation));
  //       if (res.checkResult.getLocation == false) {
  //         alert('您的微信版本太低，不支持微信JS接口，请升级到最新的微信版本！');
  //         return;
  //       }
  //     },
  //     fail: function (res) { },
  //   });
  //   wx.chooseWXPay({

  //     timestamp: timestamp, // 支付签名时间戳，秒级
  //     nonceStr: nonceStr, // 随机字符串
  //     package: packages, // 格式如："prepay_id=wx201410272009395522657a690389285100"
  //     signType: signType || 'RSA', // 签名方式，V3版统一为RSA
  //     paySign: paySign, // 签名
  //     success: function (res) {
  //       // 支付成功回调，建议以后端异步通知为准
  //       console.log('支付成功', res);
  //       // 跳转到成功页面，或提示用户
  //     },
  //     fail: function (err) {
  //       console.error('支付失败', err);
  //       // 根据err.errMsg判断是用户取消还是真正失败
  //       if (err.errMsg.includes('cancel')) {
  //         alert('您已取消支付');
  //       } else {
  //         // 处理其他失败原因，可能需提示用户或记录日志

  //       }
  //     }
  //   });
  // });

  console.log('支付参数:', {
    appId,
    nonceStr,
    timestamp,
    paySign,
    packages,
    signType
  });

  if (typeof WeixinJSBridge === 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', () => {
        onBridgeReady(paymentParams, successCallback, failCallback, cancelCallback);
      }, false);
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', () => {
        onBridgeReady(paymentParams, successCallback, failCallback, cancelCallback);
      });
      document.attachEvent('onWeixinJSBridgeReady', () => {
        onBridgeReady(paymentParams, successCallback, failCallback, cancelCallback);
      });
    }

    // 如果一段时间后仍未加载完成，可以触发失败回调
    setTimeout(() => {
      if (typeof WeixinJSBridge === 'undefined' && typeof failCallback === 'function') {
        failCallback('微信支付环境加载超时');
      }
    }, 3000);
  } else {
    onBridgeReady(paymentParams, successCallback, failCallback, cancelCallback);
  }
}

/**
 * 执行微信支付
 */
function onBridgeReady(paymentParams, successCallback, failCallback, cancelCallback) {
  const {
    appId,
    timestamp,
    nonceStr,
    packages,
    paySign,
    signType
  } = paymentParams;

 



  WeixinJSBridge.invoke(
    'getBrandWCPayRequest',
    {
      appId: appId,
      timeStamp: timestamp,
      nonceStr: nonceStr,
      package: packages,
      signType: signType || 'RSA',
      paySign: paySign,
    },
    function(res) {
      if (res.err_msg === 'get_brand_wcpay_request:ok') {
        // 支付成功
        if (typeof successCallback === 'function') {
          successCallback();
        } else {
          // 默认成功行为
          // Router.replace('/cashset/success/1');
        }
      } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
        // 取消支付
        if (typeof cancelCallback === 'function') {
          cancelCallback();
        } else {
          // 默认取消行为
          alert('取消支付');
        }
      } else {
        // 支付失败
        if (typeof failCallback === 'function') {
          failCallback(res);
        } else {
          // 默认失败行为
          // Router.replace('/cashset/success/0');
        }
      }
    }
  );
}

export default weChatPayment;
